import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useContext } from 'react';
import Media from 'react-media';
import { JsonLd } from 'react-schemaorg'; // Import Components

import { AdsenseContext, Advertisement, ArticleSchema, ContentToolBar, DfpAdUnitSetup, Layout } from '@jelly/components';
import { ReviewBody } from './ReviewBody'; // Styled components via emotion

var ReviewContainer = _styled("div", {
  target: "e14kvazq0",
  label: "ReviewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "uwwqev",
  styles: "width:100%;height:100%;"
} : {
  name: "uwwqev",
  styles: "width:100%;height:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * This the Review page's template wrapper
 */
export function Review(_ref) {
  var author = _ref.author,
      breadcrumbs = _ref.breadcrumbs,
      canonical = _ref.canonical,
      category = _ref.category,
      channels = _ref.channels,
      docType = _ref.docType,
      guid = _ref.guid,
      lastModified = _ref.lastModified,
      meta = _ref.meta,
      pricing = _ref.pricing,
      published = _ref.published,
      relatedArticles = _ref.relatedArticles,
      relatedBestPicks = _ref.relatedBestPicks,
      review = _ref.review,
      structuredData = _ref.structuredData,
      subtitle = _ref.subtitle,
      thumbnail = _ref.thumbnail,
      title = _ref.title,
      url = _ref.url;

  var _useContext = useContext(AdsenseContext),
      adsenseMediaQuery = _useContext.adsenseMediaQuery,
      hasAdsense = _useContext.hasAdsense;

  return /*#__PURE__*/React.createElement(ReviewContainer, null, /*#__PURE__*/React.createElement(Layout, {
    inverseLinkColors: true,
    meta: meta,
    hasAdDisclosure: true
  }, structuredData && /*#__PURE__*/React.createElement(JsonLd, {
    item: structuredData
  }), /*#__PURE__*/React.createElement(JsonLd, {
    item: ArticleSchema({
      content: review.fullReview,
      author: author,
      canonical: canonical,
      breadcrumbs: breadcrumbs,
      lastModified: lastModified,
      published: published,
      title: title,
      thumbnail: thumbnail
    })
  }), /*#__PURE__*/React.createElement(ContentToolBar, {
    breadcrumbs: breadcrumbs,
    canonical: canonical,
    title: title
  }), /*#__PURE__*/React.createElement(Advertisement, null), /*#__PURE__*/React.createElement(ReviewBody, {
    author: author,
    category: category,
    channels: channels,
    lastModified: lastModified,
    pricing: pricing,
    published: published,
    review: review,
    relatedBestPicks: relatedBestPicks,
    relatedArticles: relatedArticles,
    subtitle: subtitle,
    thumbnail: thumbnail,
    title: title,
    url: url
  }), hasAdsense && /*#__PURE__*/React.createElement(Media, {
    query: adsenseMediaQuery,
    defaultMatches: false
  }, function (matches) {
    return matches && /*#__PURE__*/React.createElement(DfpAdUnitSetup, {
      channels: channels,
      docType: docType,
      guid: guid
    });
  })));
}